/* eslint-disable @direct-frontend/modules/prefer-persistent-slices -- Еслинт ругается */

import { isFunction } from '@direct-frontend/stdlib';
import { type PersistentStorageKey } from './types';

/**
 * Обертка для localStorage, все обращение должны идти только через него
 * На некоторых мобильных девайсах localStorage недоступен и недоступен в SSR
 */
export const persistentStorage = {
    events: new EventTarget(),
    on(key: PersistentStorageKey, listener: EventListener) {
        this.events.addEventListener(key, listener);
    },
    off(key: PersistentStorageKey, listener: EventListener) {
        this.events.removeEventListener(key, listener);
    },
    getItem(key: PersistentStorageKey) {
        if (isFunction(localStorage?.getItem)) {
            return localStorage.getItem(key);
        }

        return null;
    },
    setItem(key: PersistentStorageKey, value: string) {
        if (isFunction(localStorage?.setItem)) {
            localStorage.setItem(key, value);
            this.events.dispatchEvent(new Event(key));
        }
    },
    removeItem(key: PersistentStorageKey) {
        if (isFunction(localStorage?.removeItem)) {
            localStorage.removeItem(key);
            this.events.dispatchEvent(new Event(key));
        }
    },
    /**
     * Проверяет доступность localStorage
     * На некоторых девайсах localStorage может быть недоступен
     */
    isAvailable() {
        try {
            /** Попытка записи/чтения тестового значения */
            const testKey = '__test__' as const;

            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Тестовый ключ не входит в типизированный список ключей
            persistentStorage.setItem(testKey as any, 'test');

            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Тестовый ключ не входит в типизированный список ключей
            const result = persistentStorage.getItem(testKey as any);

            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Тестовый ключ не входит в типизированный список ключей
            persistentStorage.removeItem(testKey as any);

            return result === 'test';
        } catch {
            return false;
        }
    },
};
